import Immutable from 'immutable';

export interface RawProjectDriveFile {
  createdAt: string;
  updatedAt: string;
  fileHash: string;
  id: string;
  name: string;
  size: number;
  key: string;
  committed: boolean;
}

const defaultValues: RawProjectDriveFile = {
  createdAt: '',
  updatedAt: '',
  fileHash: '',
  id: '',
  name: '',
  size: 0,
  key: '',
  committed: false,
};

export const ProjectDriveFileFactory = Immutable.Record(
  defaultValues,
  'ProjectDriveFile'
);

export class ProjectDriveFile extends ProjectDriveFileFactory {
  static deserialize(
    rawProjectDriveFile: RawProjectDriveFile
  ): ProjectDriveFile {
    return new ProjectDriveFile(rawProjectDriveFile);
  }

  serialize(): RawProjectDriveFile {
    return this.toJS();
  }
}
